import { TextField, TextFieldProps } from "@mui/material";
import { forwardRef, useState } from "react";

/** Keep transient empty/decimal entry local; calculations and saves receive zero. */
const WorksheetTextField = forwardRef<
  HTMLDivElement,
  TextFieldProps & { preserveBlank?: boolean; overridden?: boolean }
>(function WorksheetTextField({ preserveBlank, overridden, ...props }, ref) {
  const [draft, setDraft] = useState<string | null>(null);
  const numeric =
    !props.select && (props.type === "number" || props.inputProps?.inputMode === "decimal");
  return (
    <TextField
      {...props}
      ref={ref}
      type={numeric ? "text" : props.type}
      value={numeric && draft !== null ? draft : props.value}
      inputProps={{
        ...props.inputProps,
        ...(numeric ? { inputMode: "decimal" } : {}),
        ...(overridden ? { "aria-description": "Manually overridden" } : {}),
      }}
      sx={[
        ...(Array.isArray(props.sx) ? props.sx : [props.sx ?? {}]),
        ...(overridden
          ? [
              {
                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  { borderColor: "#d32f2f", borderWidth: "1px" },
              },
            ]
          : []),
      ]}
      onChange={(event) => {
        const raw = event.target.value;
        if (numeric && !preserveBlank && (raw === "" || raw === ".")) {
          setDraft(raw);
          props.onChange?.({
            ...event,
            target: { ...event.target, value: "0" },
            currentTarget: { ...event.currentTarget, value: "0" },
          });
        } else {
          setDraft(null);
          props.onChange?.(event);
        }
      }}
      onBlur={(event) => {
        setDraft(null);
        props.onBlur?.(event);
      }}
    />
  );
});
export default WorksheetTextField;
